<template>
  <el-table-column
    prop="name"
    sortable="custom"
    label="Név"
    show-overflow-tooltip
    fixed
    min-width="250"
  >
    <template slot-scope="scope">
      <el-link
        @click="$router.replace('/data/products/view/' + scope.row.id)"
        type="primary"
        style="display: inline;"
      >
        {{ scope.row.name }}
      </el-link>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'name',
  };
</script>
